import { authenticatedApiFetch } from '../../common/helpers';
import { numOfPeriods } from '../../common/tenor';
import { tenorOptions, gradeOptions } from '../../common/constants';
import { mapAccountPreferences } from './accountCreationMappers';
import { call, onSuccess } from 'actionware';
import { message } from 'antd';
import * as R from 'ramda';

export function toggleAccountCreationModal(action) {
  return action
}

export async function createAccount() {}

export async function updatePreferences(payload) {
  payload.tenor = payload.tenor.sort( ( a, b ) => numOfPeriods( a, "m" ) - numOfPeriods( b, "m" ) );
  if ( R.equals( payload.tenor, tenorOptions ) ) {
    payload.tenor = "all";
  }

  payload.riskCategory = payload.riskCategory.sort( ( a, b ) => gradeOptions[ a ] - gradeOptions[ b ] )
  if ( R.equals( payload.riskCategory, Object.keys( gradeOptions ) ) ) {
    payload.riskCategory = "all";
  }

  const result = await authenticatedApiFetch('account/preferences', 'PUT', payload);
  return mapAccountPreferences(result);
}

onSuccess(updatePreferences, ({ store: { getState }, payload, store }) => {
  message.success('Update account success');
  call(toggleAccountCreationModal);
});
